// extracted by mini-css-extract-plugin
module.exports = {"body3":"styles_body3__3Z5iv"};